import PropTypes from "prop-types";
import { useState, useEffect } from "react";
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MapPicker from "react-google-map-picker";

import {
  Icon,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  Alert,
  Grid,
  ListItemText,
  ListItem,
} from "@mui/material";
import MDButton from "components/MDButton";

function GeoLocationMapPoint({ formRef, draftIndex, displayName, fieldRef, options }) {
  console.log(options ? "" : "");
  const [fieldError, showFieldError] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  const [gpsLocationCoords, setGpsLocationCoords] = useState(null);
  const [location, setLocation] = useState({});
  const [openMapDialog, setOpenMapDialog] = useState(false);

  function onLocationSuccess(position) {
    // console.log("KBJBD");
    // console.log(position.coords.accuracy);
    setLocation({
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });
    setGpsLocationCoords(null);
    setOpenMapDialog(true);
  }

  function getGPSCoords() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(onLocationSuccess, null, {
        enableHighAccuracy: true,
        timeout: 50000,
      });
    } else {
      setErrorMsg(
        "Unable to retrieve your current location. Make sure Location permissions are allowed on your browser.",
      );
      showFieldError(true);
    }
    return false;
  }

  function onLocationPicked(clat, clng) {
    setLocation({ lat: clat, lng: clng });
  }

  function captureLocation() {
    if (location) {
      setGpsLocationCoords(
        JSON.stringify({
          latitude: location.lat,
          longitude: location.lng,
        }),
      );
    }
  }

  const [hasSavedValue, setHasSavedValue] = useState(false);
  const [draftValue, setDraftValue] = useState(null);

  useEffect(() => {
    if (!formRef) return;

    const saved = localStorage.getItem(`draft_${formRef}`);
    if (!saved) return;

    try {
      const parsed = JSON.parse(saved);
      const val = parsed?.[draftIndex].values?.[fieldRef];

      if (val !== undefined && val !== null && val !== "") {
        setDraftValue(JSON.parse(val));
        setHasSavedValue(true);
      }
    } catch (e) {
      console.error("Draft parse error", e);
    }
  }, [formRef, fieldRef]);

  return (
    <MDBox mt={3}>
      {hasSavedValue ? (
        <MDBox>
          <ListItem divider>
            <MDBox mr={1}>
              <Icon color="success">check_circle</Icon>
            </MDBox>
            <ListItemText
              primary={
                <MDTypography variant="h6" fontSize={14} fontWeight="regular">
                  {displayName}
                </MDTypography>
              }
              secondary={
                <MDTypography
                  variant="caption"
                  fontSize={13}
                  fontWeight="light"
                >
                  <b>
                    <Icon color="error">pin_drop</Icon>&nbsp;GPS Captured
                  </b>
                  <br />
                  <small>
                    Latitude: {draftValue.latitude} | Longitude: {draftValue.longitude}
                  </small>
                </MDTypography>
              }
            />
            <MDButton
              size="small"
              color="warning"
              variant="outlined"
              iconOnly
              onClick={() => {
                try {
                  const key = `draft_${formRef}`;
                  const saved = localStorage.getItem(key);
                  if (!saved) return;

                  const parsed = JSON.parse(saved);

                  if (parsed?.values && fieldRef in parsed.values) {
                    delete parsed.values[fieldRef];
                  }

                  // persist updated draft
                  localStorage.setItem(key, JSON.stringify(parsed));

                  // update UI state
                  setHasSavedValue(false);
                  setDraftValue(null);
                } catch (e) {
                  console.error("Failed to clear draft field", e);
                }
              }}
            >
              <Icon>edit</Icon>
            </MDButton>
          </ListItem>
          <input
            type="hidden"
            id={`dff_${fieldRef}`}
            name={fieldRef}
            value={JSON.stringify(draftValue)}
          />
        </MDBox>
      ) : (
        <MDBox>
          <Snackbar
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            autoHideDuration={5000}
            onClose={() => showFieldError(false)}
            open={fieldError}
          >
            <Alert severity="error" sx={{ width: "100%" }}>
              {errorMsg}
            </Alert>
          </Snackbar>
          <Dialog open={openMapDialog} fullWidth maxWidth="sm">
            <DialogTitle>
              <MDBox>Pick (Drag) Location</MDBox>
            </DialogTitle>
            <DialogContent>
              <MDBox mt={2} mb={3}>
                {location && (
                  <div style={{ height: "75vh", width: "100%" }}>
                    <MapPicker
                      defaultLocation={location}
                      zoom={14}
                      mapTypeId="roadmap"
                      style={{ height: "75vh" }}
                      onChangeLocation={(lat, lng) => {
                        onLocationPicked(lat, lng);
                      }}
                      // onChangeZoom={handleChangeZoom}
                      apiKey="AIzaSyCmiv_wy1kjzBT6tcvMK56pdhfpG32Ljw0"
                    />
                  </div>
                )}
              </MDBox>
            </DialogContent>
            <DialogActions>
              <MDButton
                onClick={() => {
                  setOpenMapDialog(false);
                }}
                color="dark"
                iconOnly
                circular
                variant="outlined"
              >
                <Icon>close</Icon>
              </MDButton>
              &nbsp;
              <MDButton
                color="info"
                variant="outlined"
                iconOnly
                circular
                onClick={() => {
                  captureLocation();
                  setOpenMapDialog(false);
                }}
              >
                <Icon>save</Icon>
              </MDButton>
            </DialogActions>
          </Dialog>
          <MDBox>
            <Grid container spacing={3}>
              <Grid item xs={8} md={8} lg={8}>
                <MDTypography
                  variant="h6"
                  fontWeight="light"
                  fontSize="small"
                  mb={2}
                >
                  {displayName}
                </MDTypography>
              </Grid>
              <Grid item xs={4} md={4} lg={4}>
                <MDBox align="right">
                  <MDButton
                    iconOnly
                    size="small"
                    variant="contained"
                    color="primary"
                    // startIcon={<Icon>location_on</Icon>}
                    onClick={() => {
                      getGPSCoords();
                    }}
                  >
                    <Icon>location_on</Icon>
                  </MDButton>
                </MDBox>
              </Grid>
            </Grid>
          </MDBox>
          <MDBox>
            {gpsLocationCoords !== null && location && (
              <MDTypography variant="caption" fontSize={14} fontWeight="light">
                <b>
                  <Icon color="error">pin_drop</Icon>&nbsp;GPS Captured
                </b>
                <br />
                <small>
                  Latitude: {location.lat} | Longitude: {location.lng}
                </small>
              </MDTypography>
            )}
          </MDBox>
          <input
            type="hidden"
            id={`dff_${fieldRef}`}
            name={`${fieldRef}`}
            value={gpsLocationCoords}
          />
        </MDBox>
      )}
    </MDBox>
  );
}

// Typechecking props of the Transaction
GeoLocationMapPoint.propTypes = {
  formRef: PropTypes.string.isRequired,
  fieldRef: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.any),
};

GeoLocationMapPoint.defaultProps = {
  options: null,
};

export default GeoLocationMapPoint;
